module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/471.9d117d94.png";